import { render, staticRenderFns } from "./configBigData.vue?vue&type=template&id=231fb7f4&"
import script from "./configBigData.vue?vue&type=script&lang=js&"
export * from "./configBigData.vue?vue&type=script&lang=js&"
import style0 from "./configBigData.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports